<template>
  <div class="">
    <section class="bg-n3black text-white relative">
      <div class="container" v-if="!fetchingData">
        <div class="text-title font-bold mb-5">Existing Reservation</div>
        <div class="content-text exist-checkout">
          <p class="mb-10">
            We've noticed that you have an existing reservation for the show
            {{ reservation.event?.name }} scheduled at
            {{ dateTimeFormat(reservation.event?.date.toDate()) }} in
            {{ reservation.event?.location.city }}.
          </p>

          <ul>
            <li>
              Complete Your Current Reservation: If you're still interested in
              the current reservation, you can continue and finalize your
              booking.
            </li>
            <li>
              Start a New Reservation: If you wish to make a fresh booking, you
              can start a new reservation by selecting your desired showtime and
              seats.
            </li>
          </ul>
        </div>
        <div class="py-10">
          <default-button
            label="Start a New Reservation"
            class="border-gray-500 mr-5 mb-5 w-full sm:w-2/6"
            @click="handleNewBooking"
          />
          <default-button
            label="Complete Your Current Reservation"
            class="w-full sm:w-2/5"
            @click="handleExistBooking"
          />
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import {
  computed,
  onMounted,
  onUnmounted,
  reactive,
  toRefs,
} from "@vue/runtime-core";
import { useStore } from "vuex";
import DefaultButton from "@/components/button/DefaultButton.vue";
import { useRoute, useRouter } from "vue-router";
import { dateTimeFormat } from "@/utils/helper";
import { useMeta } from "vue-meta";
export default {
  name: "PaymentSummaryPage",
  components: { DefaultButton },
  setup() {
    useMeta({
      title: "Existing Reservation",
    });
    const store = useStore();
    const route = useRoute();
    const router = useRouter();
    const state = reactive({
      show: computed(() => store.state.show.show),
      reservation: computed(() => store.state.reservation.reservation),
      fetchingData: computed(() => store.state.reservation.fetchingData),
      stripeSession: computed(() => store.state.reservation.stripeSession),
      showId: computed(() => store.state.reservation.showId),
    });
    onUnmounted(() => {
      store.dispatch("event/setState", { key: "showHeader", value: false });
    });

    onMounted(async () => {
      store.dispatch("event/setState", { key: "showHeader", value: true });
      await store.dispatch("show/findShow", route.params.showSlug);
    });

    const handleExistBooking = () => {
      router.push(
        `/${route.params.showSlug}/${state.show.tickets ? "standing" : "seat"}`
      );
    };

    const handleNewBooking = async () => {
      await store.dispatch("reservation/detach");
      router.push({ name: "home" });
    };

    return {
      ...toRefs(state),
      dateTimeFormat,
      handleNewBooking,
      handleExistBooking,
    };
  },
};
</script>
<style lang="scss">
.exist-checkout {
  ul {
    margin-left: 2rem;
    list-style: disc;
  }
}
</style>
